import type {
  InternalAxiosRequestConfig,
  AxiosError,
  AxiosResponseTransformer,
} from 'axios';
import type { InterceptorFactory } from './types';

/**
 * JSON interceptor
 * - Replaces default JSON transformResponse
 * - Strips Angular-style XSSI prefixes and parses JSON safely
 */
export const jsonInterceptor: InterceptorFactory = {
  request: () => ({
    onFulfilled: (
      config: InternalAxiosRequestConfig
    ): InternalAxiosRequestConfig => {
      const isJsonResponse =
        config.responseType === undefined ||
        config.responseType === 'json';

      const hasTransformers = Array.isArray(
        config.transformResponse
      );

      if (isJsonResponse && hasTransformers) {
        return {
          ...config,
          transformResponse: jsonResponseTransformer,
        };
      }

      return config;
    },
    onRejected: (error: AxiosError): Promise<never> =>
      Promise.reject(error),
  }),
};

const jsonResponseTransformer: AxiosResponseTransformer = (
  data: unknown
): unknown => {
  const XSSI_PREFIX = /^\)\]\}',?\n/;

  if (typeof data !== 'string') {
    return data;
  }

  const cleaned = data.replace(XSSI_PREFIX, '');

  if (cleaned === '') {
    return null;
  }

  try {
    return JSON.parse(cleaned);
  } catch {
    return data;
  }
};